import Vue from "vue";
import Vuex from "vuex";
import isMobile from "ismobilejs/dist/isMobile.min.js";
import jsonp from "../utils/jsonp";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isWap: false, // 是否宽度小于940，判断为手机样式显示
        isShowGoDialog: false, // 控制UI上是否显示网页充值弹窗
        ismobile: isMobile.any,
        visitorId: "", //  访客ID
        cookieAllowed: false, //  是否允许cookie
        isSwitchLangVisible: false, // 是否显示选择语言列表
        agentName: "", // 浏览器品牌
        agentVersion: "", //浏览器版本
        clientResolution: "", //  显示分辨率
        pageUrl: "", // 页面地址
        referrerUrl: "", // 来源URL
        urlParams: {
            player_token: "",
            role_id: "",
            game_code: "",
            server_id: "",
            os: "",
            language: ""
        }
    },
    mutations: {
        SET_IS_SHOW_GO_DIALOG(state, visitId) {
            state.isShowGoDialog = visitId;
        },
        SET_IS_WAP(state, isWap) {
            state.isWap = isWap;
        },
        SET_COOKIE_ALLOWED(state, isAllowed) {
            state.cookieAllowed = isAllowed;
        },
        SET_SWITCH_LANG_VISIBLE(state, status) {
            state.isSwitchLangVisible = status;
        },
        SET_VISITOR_ID(state, visitId) {
            state.visitorId = visitId;
        },
        SET_AGENT_NAME(state, name) {
            state.agentName = name;
        },
        SET_AGENT_VERSION(state, version) {
            state.agentVersion = version;
        },
        SET_CLIENT_RESOLUTION(state, resolution) {
            state.clientResolution = resolution;
        },
        SET_PAGE_URL(state, url) {
            state.pageUrl = url;
        },
        SET_REFERRER_URL(state, url) {
            state.referrerUrl = url;
        },
        SET_URL_PARAMS(state, params) {
            state.urlParams = params;
        }
    },
    actions: {
        SHOW_GO_DIALOG({ commit }) {
            commit("SET_IS_SHOW_GO_DIALOG", true);
        },
        HIDE_GO_DIALOG({ commit }) {
            commit("SET_IS_SHOW_GO_DIALOG", false);
        },
        IS_WAP({ commit }) {
            commit("SET_IS_WAP", true);
        },
        NOT_WAP({ commit }) {
            commit("SET_IS_WAP", false);
        },
        SHOW_SWITHC_LANG({ commit }) {
            commit("SET_SWITCH_LANG_VISIBLE", true);
        },
        HIDE_SWITHC_LANG({ commit }) {
            commit("SET_SWITCH_LANG_VISIBLE", false);
        },
        MDATA_VISIT_PAGE({ state }) {
            let data = {
                appid: process.env.VUE_APP_MDATA_APPID,
                event: "page_visit",
                server_id: "0",
                uuid: state.visitorId, // 这里应填入具体的 UUID，如果需要
                udid: state.visitorId,
                locale: "en",
                browser: state.agentName,
                promotion_string: "",
                directed: "0",
                session_properties: {
                    app_id: process.env.VUE_APP_MDATA_APPID,
                    visitor_id: state.visitorId,
                    cookie_allowed: state.cookieAllowed,
                    agent_name: state.agentName,
                    agent_version: state.agentVersion,
                    client_resolution: state.clientResolution,
                    page_url: state.pageUrl,
                    page_source: state.referrerUrl
                }
            };
            jsonp(
                process.env.VUE_APP_MDATA_DOMAIN +
                    "/mdata.php?data=" +
                    JSON.stringify(data)
            );
        },
        MDATA_CLICK_BUTTON({ state }, buttonName) {
            let data = {
                appid: process.env.VUE_APP_MDATA_APPID,
                event: "button_click",
                server_id: "0",
                uuid: state.visitorId, // 这里应填入具体的 UUID，如果需要
                udid: state.visitorId,
                locale: "en",
                browser: state.agentName,
                promotion_string: "",
                directed: "0",
                session_properties: {
                    app_id: process.env.VUE_APP_MDATA_APPID,
                    visitor_id: state.visitorId,
                    cookie_allowed: state.cookieAllowed,
                    agent_name: state.agentName,
                    agent_version: state.agentVersion,
                    client_resolution: state.clientResolution,
                    button_name: buttonName
                }
            };
            jsonp(
                process.env.VUE_APP_MDATA_DOMAIN +
                    "/mdata.php?data=" +
                    JSON.stringify(data)
            );
        },
        SET_COOKIE_ALLOWED({ state }, isAllowed) {
            state.cookieAllowed = isAllowed;
        },
        SET_VISITOR_ID({ commit }, visitId) {
            commit("SET_VISITOR_ID", visitId);
        },
        SAVE_URL_PARAMS({ commit }) {
            const urlParams = new URLSearchParams(window.location.search);
            const keys = ['player_token', 'role_id', 'game_code', 'server_id', 'os', 'language'];
            const params = {};
            keys.forEach(key => {
                params[key] = urlParams.get(key) || "";
            });
            commit('SET_URL_PARAMS', params);
        },
        INIT_MDATA_INFO({ commit }) {
            // 获取浏览器信息
            const userAgent = navigator.userAgent;
            let browserName = navigator.appName;
            let fullVersion = "" + parseFloat(navigator.appVersion);
            let nameOffset, verOffset;

            // In Opera, the true version is after "Opera" or after "Version"
            if ((verOffset = userAgent.indexOf("Opera")) !== -1) {
                browserName = "Opera";
                fullVersion = userAgent.substring(verOffset + 6);
                if ((verOffset = userAgent.indexOf("Version")) !== -1)
                    fullVersion = userAgent.substring(verOffset + 8);
            }
            // In MSIE, the true version is after "MSIE" in userAgent
            else if ((verOffset = userAgent.indexOf("MSIE")) !== -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = userAgent.substring(verOffset + 5);
            }
            // In Chrome, the true version is after "Chrome"
            else if ((verOffset = userAgent.indexOf("Chrome")) !== -1) {
                browserName = "Chrome";
                fullVersion = userAgent.substring(verOffset + 7);
            }
            // In Safari, the true version is after "Safari" or after "Version"
            else if ((verOffset = userAgent.indexOf("Safari")) !== -1) {
                browserName = "Safari";
                fullVersion = userAgent.substring(verOffset + 7);
                if ((verOffset = userAgent.indexOf("Version")) !== -1)
                    fullVersion = userAgent.substring(verOffset + 8);
            }
            // In Firefox, the true version is after "Firefox"
            else if ((verOffset = userAgent.indexOf("Firefox")) !== -1) {
                browserName = "Firefox";
                fullVersion = userAgent.substring(verOffset + 8);
            }
            // In most other browsers, "name/version" is at the end of userAgent
            else if (
                (nameOffset = userAgent.lastIndexOf(" ") + 1) <
                (verOffset = userAgent.lastIndexOf("/"))
            ) {
                browserName = userAgent.substring(nameOffset, verOffset);
                fullVersion = userAgent.substring(verOffset + 1);
                if (browserName.toLowerCase() === browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // Trim the fullVersion string at semicolon/space if present
            if ((verOffset = fullVersion.indexOf(";")) !== -1)
                fullVersion = fullVersion.substring(0, verOffset);
            if ((verOffset = fullVersion.indexOf(" ")) !== -1)
                fullVersion = fullVersion.substring(0, verOffset);
            commit("SET_AGENT_NAME", browserName);
            commit("SET_AGENT_VERSION", fullVersion);
            // 设置显示分辨率
            commit("SET_CLIENT_RESOLUTION", `${screen.width}x${screen.height}`);
            // 设置页面地址（不含Query信息）
            const pageUrl = window.location.href.split("?")[0]; // 移除URL中的查询参数
            commit("SET_PAGE_URL", encodeURIComponent(pageUrl));
            // 设置来源URL
            const referrerUrl = encodeURIComponent(document.referrer); // 获取来源URL
            commit("SET_REFERRER_URL", referrerUrl);
        }
    },
    modules: {}
});
